export interface ChartData {
  value: number | string;
  color: string;
  tooltipText?: string;
}
